import { CanvasScene } from './scenes/Board/CanvasScene';
import { LevelSelectionScene } from './scenes/LevelSelection/LevelSelectionScene';
import { PreloadScene } from "./scenes/PreloadScene";
import { GameConstants } from "./GameConstants";
import { GameVars } from "./GameVars";
import { BootScene } from "./scenes/BootScene";
import { CanvasManager } from "./scenes/Board/CanvasManager";
import { AudioManager } from "./AudioManager";

export class GameManager {

    public static scenesList: any;
    public static ignorePainting: boolean = false;

    public static init(): void {

        GameVars.canvasTextures = {};
        GameManager.scenesList = PreloadScene.currentInstance.sys.scene.registry.getAll();

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_NONE) {
            if (top.location.href.indexOf("footchinko.com") > -1 || top.location.href.indexOf("ravalmatic.com") > -1 || top.location.href.indexOf("127") > -1 || top.location.href.indexOf("localhost") > -1) {
                GameManager.readGameData();
            }

        } else if (GameConstants.SPONSOR === GameConstants.SPONSOR_FUNO) {
            
            const domains = ["funo.com", "yurk.com", "friv.com", "femo.com", "fabo.com", "friv.co.uk", "friv4school.com", "frivmath.com", "funomath.com", "localhost", "127", "192", "footchinko.com"];
                
            if (GameVars.areValidDomains(domains)) {
                GameManager.readGameData();
            }

        } else if (GameConstants.SPONSOR === GameConstants.SPONSOR_LAGGED) {
            
            const domains = ["lagged.com", "gamesbutler.com", "localhost", "127", "192", "footchinko.com"];
                
            if (GameVars.areValidDomains(domains)) {
                GameManager.readGameData();
            }
        } else if (GameConstants.SPONSOR === GameConstants.GAME_DISTRIBUTION) {
            GameManager.initGameDistributionSDK();
            GameManager.readGameData();
        }
    }

    public static initGameDistributionSDK(): void {

        window["GD_OPTIONS"] = {
            "gameId": "7270ce4b91624371a37122f240dff5e8",
            "onEvent": function(event: any): any {
                switch (event.name) {
                    case "SDK_GAME_START":
                        if (!GameVars.gameData.muted) {
                            AudioManager.audioSpriteManager.setMute(false);
                        }
                        if (GameVars.typeAd === "Canvas") {
                            LevelSelectionScene.currentInstance.scene.start("CanvasScene");
                        } else if (GameVars.typeAd === "Selection") {
                            CanvasScene.currentInstance.scene.start("LevelSelectionScene");
                        }
                        break;
                    case "SDK_GAME_PAUSE":
                        AudioManager.audioSpriteManager.setMute(true);
                        break;
                    case "SDK_GDPR_TRACKING":
                        console.log("SDK_GDPR_TRACKING");
                        break;
                    case "SDK_GDPR_TARGETING":
                        console.log("SDK_GDPR_TARGETING");
                        break;
                    default:
                        break;
                }
            },
        };
        (function(d: any, s: any, id: any): any {
            var js: any, fjs: any = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) { return; }
            js = d.createElement(s);
            js.id = id;
            js.src = "https://html5.api.gamedistribution.com/main.min.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, "script", "gamedistribution-jssdk"));
    }

    public static captureMouseRelease(): void {

        for (let y = 0; y < CanvasManager.heightInCells; y++) {
            for (let x = 0; x < CanvasManager.widthInCells; x++) {

                if (GameVars.pixelTiles[y][x] !== null) {
                    GameVars.pixelTiles[y][x].containMouse = false;
                    GameVars.pixelTiles[y][x].tilePressed = false;
                }
            }
        }
    }

    public static readGameData(): void {

        GameManager.getGameStorageData(
            GameConstants.SAVED_GAME_DATA_KEY,
            function (gameData: string): void {

                if (gameData) {
                    GameVars.gameData = JSON.parse(gameData);
                } else {

                    GameVars.gameData = {
                        muted: false,
                        drawingsData: null,
                    };

                    let data = GameManager.setNewUserData();
                    GameVars.gameData.drawingsData = data;
                }

                GameManager.startGame();
            },
            function (error: Error): void {
                GameManager.log("error retriving saved game data.", error);
            }
        );
    }

    public static saveDrawData(): void {

        if (this.saveDrawState()) {
            this.savePixelState();
        }
    }

    public static setNewUserData(): DrawingsData {

        let data: DrawingsData;

        data = {
            categoryDrawState: [],
            pixelDrawState: [],
        };

        let drawInfo: number[];
        drawInfo = [];

        // Fill Animal Category ---

        for (let i = 0; i < GameVars.animalAmount; i++) {
            drawInfo.push(0);
        }

        data.categoryDrawState.push(drawInfo);
        drawInfo = [];

        // Fill Food Category ---

        for (let i = 0; i < GameVars.foodAmount; i++) {
            drawInfo.push(0);
        }

        data.categoryDrawState.push(drawInfo);
        drawInfo = [];

        // Fill Human Category ---

        for (let i = 0; i < GameVars.peopleAmount; i++) {
            drawInfo.push(0);
        }

        data.categoryDrawState.push(drawInfo);
        drawInfo = [];

        // Fill Miscelanea Category ---

        for (let i = 0; i < GameVars.stuffAmount; i++) {
            drawInfo.push(0);
        }

        data.categoryDrawState.push(drawInfo);
        drawInfo = [];

        // Fill Monsters Category ---

        for (let i = 0; i < GameVars.monstersAmount; i++) {
            drawInfo.push(0);
        }

        data.categoryDrawState.push(drawInfo);
        drawInfo = [];

        // Fill Plants Category ---

        for (let i = 0; i < GameVars.plantsAmount; i++) {
            drawInfo.push(0);
        }

        data.categoryDrawState.push(drawInfo);
        drawInfo = [];

        // Fill Vehicles Category ---

        for (let i = 0; i < GameVars.vehiclesAmount; i++) {
            drawInfo.push(0);
        }

        data.categoryDrawState.push(drawInfo);

        // Pixel Data will be empty at the start 
        data.pixelDrawState = [];

        return data;
    }

    public static onGameAssetsLoaded(scene: Phaser.Scenes.ScenePlugin): void {

        AudioManager.init();
       
        GameManager.setCategoryCounts();

        scene.switch("HomeScene");
    }

    public static setCategoryCounts(): void {

        var imageFrames = GameVars.currentScene.game.cache.json.entries.entries["texture_atlas_0"]["frames"];

        for (let i = 0; i < imageFrames.length; i++) {

            const fileName = imageFrames[i]["filename"];
            const categoryName = fileName.split("_")[0];
            const isGS = fileName.split("_")[2] === "gs";
            if (isGS) { continue; }

            switch (categoryName) {
                case "animals": GameVars.animalAmount++; break;
                case "food": GameVars.foodAmount++; break;
                case "monsters": GameVars.monstersAmount++; break;
                case "humans": GameVars.peopleAmount++; break;
                case "plants": GameVars.plantsAmount++; break;
                case "stuff": GameVars.stuffAmount++; break;
                case "vehicles": GameVars.vehiclesAmount++; break;
                default: continue;
            }
        }
    }

    public static writeGameData(): void {

        GameManager.setGameStorageData(
            GameConstants.SAVED_GAME_DATA_KEY,
            GameVars.gameData,
            function (): void {
                GameManager.log("game data successfully saved");
            },
            function (error: Error): void {
                GameManager.log("error saving game data", error);
            }
        );
    }

    public static log(text: string, error?: Error): void {

        if (!GameConstants.VERBOSE) {
            return;
        }

        if (error) {
            console.error(text + ":", error);
        } else {
            console.log(text);
        }
    }

    public static isDrawSaved(categoryID: number, drawID: number): boolean { // Check if the draw has been saved, if it is it will return the array

        for (let i = 0; i < GameVars.gameData.drawingsData.pixelDrawState.length; i++) {

            if (GameVars.gameData.drawingsData.pixelDrawState[i][0] === categoryID) {
                if (GameVars.gameData.drawingsData.pixelDrawState[i][1] === drawID) {

                    // If the code reaches this point, means the pixelData has already been saved
                    return true;
                }
            }
        }

        return false;
    }

    public static deletePixelData(categoryID: number, drawID: number): void {

        if (!GameManager.isDrawSaved(categoryID, drawID)) {
            return;
        }

        for (let i = 0; i < GameVars.gameData.drawingsData.pixelDrawState.length; i++) {

            if (GameVars.gameData.drawingsData.pixelDrawState[i][0] === categoryID) {
                if (GameVars.gameData.drawingsData.pixelDrawState[i][1] === drawID) {

                    delete GameVars.gameData.drawingsData.pixelDrawState[i];
                    GameVars.gameData.drawingsData.pixelDrawState.splice(i, 1);

                }
            }
        }
    }

    public static getPixelData(categoryID: number, drawID: number): number[] {

        if (!GameManager.isDrawSaved(categoryID, drawID)) {
            return;
        }

        for (let i = 0; i < GameVars.gameData.drawingsData.pixelDrawState.length; i++) {

            if (GameVars.gameData.drawingsData.pixelDrawState[i][0] === categoryID) {
                if (GameVars.gameData.drawingsData.pixelDrawState[i][1] === drawID) {

                    // If the code reaches this point, means the pixelData has already been saved
                    return GameVars.gameData.drawingsData.pixelDrawState[i];

                }
            }
        }

        return null;
    }

    public static getCategoryFromID(categoryID: number): string {

        let ret: string;

        switch (categoryID) {

            case 0:
                ret = "ANIMALS";
                break;
            case 1:
                ret = "FOOD";
                break;
            case 2:
                ret = "HUMANS";
                break;
            case 3:
                ret = "STUFF";
                break;
            case 4:
                ret = "MONSTERS";
                break;
            case 5:
                ret = "PLANTS";
                break;
            case 6:
                ret = "VEHICLES";
                break;
            default:
                break;
        }

        return ret;
    }

    public static getFileFormatCategory(category: string): string { // To not create a function that sets letters to lowercase...

        let ret: string;

        switch (category) {

            case "ANIMALS":
                ret = "animals";
                break;

            case "FOOD":
                ret = "food";
                break;

            case "HUMANS":
                ret = "humans";
                break;

            case "STUFF":
                ret = "stuff";
                break;

            case "MONSTERS":
                ret = "monsters";
                break;

            case "PLANTS":
                ret = "plants";
                break;

            case "VEHICLES":
                ret = "vehicles";
                break;

            default:
                break;
        }

        return ret;
    }

    public static getIDfromCategory(category: string): number {

        let ret: number;

        switch (category) {

            case "ANIMALS":
                ret = 0;
                break;

            case "FOOD":
                ret = 1;
                break;

            case "HUMANS":
                ret = 2;
                break;

            case "STUFF":
                ret = 3;
                break;

            case "MONSTERS":
                ret = 4;
                break;

            case "PLANTS":
                ret = 5;
                break;

            case "VEHICLES":
                ret = 6;
                break;

            default:
                break;
        }

        return ret;
    }

    public static getDrawState(categoryID: number, drawID: number): drawState {

        let ret: drawState;

        const state_num = GameVars.gameData.drawingsData.categoryDrawState[categoryID][drawID];

        switch (state_num) {

            case 0:
                ret = drawState.DRAW_EMPTY;
                break;

            case 1:
                ret = drawState.DRAW_INPROGRESS;
                break;

            case 2:
                ret = drawState.DRAW_FINISHED;
                break;

            default:
                ret = drawState.DRAW_NULL;
                break;
        }

        return ret;
    }

    public static setDrawState(categoryID: number, drawID: number, drawstate: drawState): void {

        switch (drawstate) {

            case drawState.DRAW_EMPTY:
                GameVars.gameData.drawingsData.categoryDrawState[categoryID][drawID] = 0;
                break;

            case drawState.DRAW_INPROGRESS:
                GameVars.gameData.drawingsData.categoryDrawState[categoryID][drawID] = 1;
                break;

            case drawState.DRAW_FINISHED:
                GameVars.gameData.drawingsData.categoryDrawState[categoryID][drawID] = 2;
                break;

            default:
                break;
        }
    }

    private static startGame(): void {

        BootScene.currentInstance.scene.start("PreloadScene");
    }

    private static getGameStorageData(key: string, successCb: Function, failureCb: Function): void {

        const gameDataStr = localStorage.getItem(key);
        successCb(gameDataStr);
    }

    private static setGameStorageData(key: string, value: any, successCb: Function, failureCb: Function): void {

        const string = JSON.stringify(value);
        localStorage.setItem(key, string);
        successCb();
    }

    private static saveDrawState(): boolean {   // Will save the state of the draw (not the pixels)

        let ret = false;

        let percentage = CanvasManager.getDrawFillPercentage();

        if (percentage !== drawState.DRAW_EMPTY) {

            if (percentage === drawState.DRAW_FINISHED) {
                GameVars.gameData.drawingsData.categoryDrawState[GameVars.currentDrawCategoryID][GameVars.currentDrawId] = drawState.DRAW_FINISHED;
            } else {
                GameVars.gameData.drawingsData.categoryDrawState[GameVars.currentDrawCategoryID][GameVars.currentDrawId] = drawState.DRAW_INPROGRESS;
                ret = true;
            }
        }

        return ret;
    }

    private static savePixelState(): void {   // Will manage the info generated with savePixelArray (overwrite or not)     

        let newArray = GameManager.savePixelArray();

        if (!GameManager.isDrawSaved(GameVars.currentDrawCategoryID, GameVars.currentDrawId)) { // Draw has been never saved. Create it  
            GameVars.gameData.drawingsData.pixelDrawState.push(newArray);

        } else { // Overwrite the draw that already exists
            let index = GameManager.getPosInPixelState(GameVars.currentDrawCategoryID, GameVars.currentDrawId);
            GameVars.gameData.drawingsData.pixelDrawState[index] = newArray;
        }

        if (newArray !== null) {
            GameManager.setDrawState(GameVars.currentDrawCategoryID, GameVars.currentDrawId, drawState.DRAW_INPROGRESS);
        }
    }

    private static getPosInPixelState(categoryID: number, drawID: number): number { // Get the position where the pixel data is inside the array

        let count = 0;
        GameVars.gameData.drawingsData.pixelDrawState.forEach(current => {

            if (current[0] === categoryID && current[1] === drawID) {
                return count;
            }

            count++;
        });

        return count;
    }

    private static savePixelArray(): number[] { // Will save the array of pixels from the "done" tiles

        let dataArray: number[] = [];

        dataArray[0] = GameVars.currentDrawCategoryID;             // Save Category ID
        dataArray[1] = GameVars.currentDrawId;                     // Save Draw ID
        dataArray[2] = CanvasManager.getDrawFillPercentage();      // Save done/notDone

        for (let x = 0; x < CanvasManager.widthInCells; x++) {       // Save Pixel Data
            for (let y = 0; y < CanvasManager.heightInCells; y++) {

                if (GameVars.pixelTiles[y][x] === null) {
                    continue;
                }

                if (GameVars.pixelTiles[y][x].isDone() && dataArray[2] <= 0.5) {
                    dataArray.push(GameVars.pixelTiles[y][x].tileID);

                } else if (!GameVars.pixelTiles[y][x].isDone() && dataArray[2] > 0.5) {
                    dataArray.push(GameVars.pixelTiles[y][x].tileID);
                }
            }
        }

        return dataArray;
    }
}
